"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaptionedMedia = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _Typography = require("../Typography");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["as", "media", "caption", "aspectRatio", "rounded", "slots", "slotProps"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Note: Width full and aspect ratio together will prevent content layout shift.
 * Object cover seemed like a sensible default; but can be overriden with slot props.
 */
var classesMedia = (0, _classVarianceAuthority.cva)(['w-full', 'object-cover'], {
  variants: {
    aspectRatio: {
      '16:9': ['aspect-video'],
      '4:3': ['aspect-4/3'],
      '1:1': ['aspect-square'],
      '3:4': ['aspect-3/4'],
      'none': ['aspect-auto']
    },
    rounded: {
      "true": ['rounded-xl'],
      "false": []
    }
  }
});

/**
 * Captioned Media - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/data-display-captionedmedia) | [DSM](https://sharphealthcare.notion.site/Captioned-media-40471d1fec01491698e86af36433942d)
 *
 * @example
 *
 * <CaptionedMedia
 *  media={{ src: 'image.jpg' }}
 *  aspectRatio="4:3"
 *  caption="Cool image"
 *  rounded />
 *
 * <CaptionedMedia
 *  media={{ src: 'https://youtube.com/' }}
 *  caption={<>JSX captions <strong>work</strong></>} />
 *  slots={{ media: MyVideoPlayer }} />
 *
 */
var CaptionedMedia = exports.CaptionedMedia = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _slots$media, _slotProps$media, _slots$caption, _slotProps$caption, _slotProps$caption2;
  var _props$as = props.as,
    Root = _props$as === void 0 ? 'figure' : _props$as,
    _props$media = props.media,
    media = _props$media === void 0 ? {} : _props$media,
    caption = props.caption,
    _props$aspectRatio = props.aspectRatio,
    aspectRatio = _props$aspectRatio === void 0 ? '16:9' : _props$aspectRatio,
    _props$rounded = props.rounded,
    rounded = _props$rounded === void 0 ? false : _props$rounded,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    rest = _objectWithoutProperties(props, _excluded);
  var Media = (_slots$media = slots === null || slots === void 0 ? void 0 : slots.media) !== null && _slots$media !== void 0 ? _slots$media : 'img';
  var mediaPropClassName = media.className,
    mediaPropProps = _objectWithoutProperties(media, _excluded2);
  var _ref = (_slotProps$media = slotProps === null || slotProps === void 0 ? void 0 : slotProps.media) !== null && _slotProps$media !== void 0 ? _slotProps$media : {},
    mediaSlotPropsClassName = _ref.className,
    mediaSlotProps = _objectWithoutProperties(_ref, _excluded3);
  var mediaProps = slots !== null && slots !== void 0 && slots.media ? _objectSpread({}, mediaSlotProps) : _objectSpread(_objectSpread({}, mediaPropProps), mediaSlotProps);
  var Caption = (_slots$caption = slots === null || slots === void 0 ? void 0 : slots.caption) !== null && _slots$caption !== void 0 ? _slots$caption : _Typography.Typography;
  var _ref2 = (_slotProps$caption = slotProps === null || slotProps === void 0 ? void 0 : slotProps.caption) !== null && _slotProps$caption !== void 0 ? _slotProps$caption : {},
    captionSlotPropsClassName = _ref2.className,
    captionSlotProps = _objectWithoutProperties(_ref2, _excluded4);
  var captionDefaultProps = {
    as: 'figcaption',
    variant: 'small-body',
    align: 'left'
  };
  var captionProps = slots !== null && slots !== void 0 && slots.caption ? captionSlotProps : _objectSpread(_objectSpread({}, captionDefaultProps), captionSlotProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Media, _objectSpread({
      className: (0, _helpers.cn)(classesMedia({
        aspectRatio: aspectRatio,
        rounded: rounded
      }), mediaSlotPropsClassName)
    }, mediaProps)), (caption !== null && caption !== void 0 ? caption : slotProps === null || slotProps === void 0 || (_slotProps$caption2 = slotProps.caption) === null || _slotProps$caption2 === void 0 ? void 0 : _slotProps$caption2.children) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Caption, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)('mt-3 empty:hidden', captionSlotPropsClassName)
    }, captionProps), {}, {
      children: caption
    }))]
  }));
});